export const mutations = {
  /**
   * set external platform details
   * @param {Object} objectTemplate
   */
  setPlatformDetails(state, platformDetails) {
    state.platformDetails = platformDetails;
  },

  /**
   * set external platform access to invalid
   * @param {Boolean} invalid
   */
  setInvalid(state, invalid) {
    state.invalid = invalid;
  },

  /**
   * set external record
   * @param {Object} record
   */
  setExternalRecord(state, record) {
    state.externalRecord = { ...record };
  },

  /**
   * set external files
   * @param {Object} record
   */
  setExternalFiles(state, externalFiles) {
    state.externalFiles = { ...externalFiles };
  }
};
